// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import delay from '../../../../../../../../common/utils/lib/delay';
import {
    getIsPublishedFeedbackEnabled,
    getTitle,
} from '../../../../../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { publishBoard } from '../publishBoardActions';

// Components
import ToggleInput from '../../../../../../../components/form/fields/ToggleInput';
import TooltipSource from '../../../../../../../components/tooltips/TooltipSource';
import SettingsRow from '../../../../../../../user/account/accountModal/components/SettingsRow';

// Constants
import { TIMES } from '../../../../../../../../common/utils/timeUtil';
import { TooltipPositions } from '../../../../../../../components/tooltips/tooltipConstants';

const mapDispatchToProps = (dispatch) => ({
    dispatchPublishBoard: (args) => dispatch(publishBoard(args)),
});

const PublishBoardCommentToggle = (props) => {
    const {
        isPublished,
        canModifySettings,
        currentBoard,
        currentBoardId,
        dispatchPublishBoard,
        showSharedAncestorBoardLink,
        publishedAncestorBoard,
    } = props;

    // Default to enabled, unless specifically disabled
    const [commentsEnabled, setCommentsEnabled] = React.useState(getIsPublishedFeedbackEnabled(currentBoard) !== false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const onToggleFeedback = async (event) => {
        const nowEnabled = event.target.checked;

        setIsLoading(true);
        setCommentsEnabled(nowEnabled);

        try {
            await dispatchPublishBoard({ boardId: currentBoardId, commentsEnabled: nowEnabled });
        } catch (err) {
            setError(err);

            await delay(1000);

            setCommentsEnabled(!nowEnabled);
            setError(null);
        }

        setIsLoading(false);
    };

    return (
        <div className="PublishBoardCommentToggle">
            <SettingsRow
                loading={isLoading}
                className="secondary-row"
                disabled={!isPublished}
                label="Allow comments, reactions & drawing"
            >
                <TooltipSource
                    className="share-link-toggle-tooltip small-text"
                    enabled={!!showSharedAncestorBoardLink}
                    triggerOnClick
                    position={TooltipPositions.BOTTOM}
                    duration={TIMES.SECOND * 3}
                    tooltipText={`Change this setting in: ${getTitle(publishedAncestorBoard)}`}
                >
                    <ToggleInput
                        error={!!error}
                        disabled={!canModifySettings}
                        active={commentsEnabled}
                        onChange={onToggleFeedback}
                    />
                </TooltipSource>
            </SettingsRow>
        </div>
    );
};

PublishBoardCommentToggle.propTypes = {
    isPublished: PropTypes.bool,
    canModifySettings: PropTypes.bool,
    showSharedAncestorBoardLink: PropTypes.bool,

    currentBoardId: PropTypes.string,
    currentBoard: PropTypes.object,
    publishedAncestorBoard: PropTypes.object,

    dispatchPublishBoard: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PublishBoardCommentToggle);
